'use strict'

import Flicking from "@egjs/flicking"

/**
 * Flicking
 */
export default () => {
  const func = {
    flickings: document.querySelectorAll('.js-flicking'),
    flicking: Array(document.querySelectorAll('.js-flicking').length),
    duration: 500,

    /**
     * init
     */
    init: () => {
      func.flickings.forEach(function(elem, index) {
        const slide = elem.querySelector('.u-flicking__slide')
        const pagination = elem.querySelector('.u-flicking__pagination')
        func.flicking[index] = new Flicking(slide, {
          circular: true,
          autoResize: true,
        })
        func.flickings[index].querySelector('.u-flicking__prev').addEventListener('click', () => {
          func.flicking[index].prev(func.duration)
        })
        func.flickings[index].querySelector('.u-flicking__next').addEventListener('click', () => {
          func.flicking[index].next(func.duration)
        })
        func.flicking[index].on('moveEnd', e => {
          func.dotCurrent(func.flicking[index].getIndex(), pagination)
        })
        func.pagination(func.flicking[index], pagination)
      })
    },

    /**
     * pagination
     */
    pagination: (flicking, pagination) => {
      const dots = document.createDocumentFragment()
      let dot
      let pages
      let index
      for (let i = 0; i < flicking.getPanelCount(); ++i) {
        dot = document.createElement('span')
        dot.classList.add('u-flicking__pagination--dot')
        dots.appendChild(dot)
      }
      pagination.appendChild(dots)
      pages = pagination.querySelectorAll('.u-flicking__pagination--dot')
      pages[flicking.getIndex()].classList.add('is-current')
      pages.forEach(PAGE => {
        PAGE.addEventListener('click', () => {
          index = [].slice.call(pages).indexOf(PAGE)
          flicking.moveTo(index, func.duration)
          pagination.querySelector('.is-current').classList.remove('is-current')
          PAGE.classList.add('is-current')
        })
      })
    },

    /**
     * dotCurrent
     */
    dotCurrent: (index, pagination) => {
      let pages
      pages = pagination.querySelectorAll('.u-flicking__pagination--dot')
      pagination.querySelector('.is-current').classList.remove('is-current')
      pages[index].classList.add('is-current')
    },
  }

  func.init()
}
